























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import Dial from "./renderComponents/Dial.vue";
import MeeetingArea from "./renderComponents/MeetingArea.vue";
import MainArea from "./renderComponents/MainArea.vue";
import SideButtons from "./renderComponents/SideButtons.vue";
import moment from "moment";
import { CalendarData, SessionSolutionProperties, SessionRenderTemplateModel } from "./types";
import signalRMixin from "./signalR";
import translations from "./translations";
import { setScreenOFF, setScreenON, setVideoPort, setVideoSwitchOFF, setVideoSwitchON } from "./sessionService";
import { FILEENDPOINT } from "@/app.config";

@Component({
    components: {
        dial: Dial,
        "meeting-area": MeeetingArea,
        "main-area": MainArea,
        "side-buttons": SideButtons
    },
    mixins: [signalRMixin]
})
export default class SessionRender extends mixins(signalRMixin) {
    @Prop() private contentRenderModel!: SessionRenderTemplateModel;
    @Prop() solutionProperties!: SessionSolutionProperties;
    @Prop() preview!: boolean;

    renderModel: SessionRenderTemplateModel = JSON.parse(JSON.stringify(this.contentRenderModel));
    solutionProps: SessionSolutionProperties = this.solutionProperties
        ? JSON.parse(JSON.stringify(this.solutionProperties))
        : { roomEmail: "", roomName: "" };

    @Watch("contentRenderModel", { deep: true }) r() {
        if (JSON.stringify(this.renderModel) !== JSON.stringify(this.contentRenderModel)) {
            this.renderModel = JSON.parse(JSON.stringify(this.contentRenderModel));
        }
    }

    @Watch("solutionProperties") s() {
        if (JSON.stringify(this.solutionProperties) !== JSON.stringify(this.solutionProps)) {
            this.solutionProps = JSON.parse(JSON.stringify(this.solutionProperties));
        }
    }

    // Time
    now = moment();
    interval = 0;
    timeout = 0;

    screenOn = false; // Only used for no-booking mode
    signalRMounted = false;
    meetingToConfirm: CalendarData | null = null;
    oldMeeting = {} as CalendarData | null;

    isBookingDisabled = this.renderModel.properties.disableBooking;
    @Watch("renderModel.properties.disableBooking") w() {
        if (!this.signalRMounted && !this.renderModel.properties.disableBooking && !this.preview) {
            this.mountSignalR();
            this.signalRMounted = true;
        }
        const forceGetData = this.isBookingDisabled && !this.renderModel.properties.disableBooking;
        this.isBookingDisabled = this.renderModel.properties.disableBooking;

        if (forceGetData) {
            console.log("Booking was changed from disabled to enabled, forcing data load");
            this.loadData(false);
        }
    }

    get logo() {
        return this.renderModel.properties.logo ? FILEENDPOINT + this.renderModel.properties.logo : require("./assets/logo.png");
    }

    get backgroundImage() {
        return this.renderModel.properties.background ? FILEENDPOINT + this.renderModel.properties.background : require("./assets/background.png");
    }

    get translations() {
        return this.renderModel.properties.language && translations[this.renderModel.properties.language] ? translations[this.renderModel.properties.language] : translations.en;
    }

    get currentMeeting() {
        if (this.preview || this.isBookingDisabled) return;
        const now = this.now; // Subscribe to now to get computed to react
        console.log("Getting current meeting");
        const today = moment();
        this.meetingToConfirm = null;

        const meeting = this.data.filter((x: CalendarData) => moment(x.StartDateTime).set("seconds", 0).isSameOrBefore(today) && moment(x.EndDateTime).isAfter(today))[0];
        if (meeting && this.renderModel.properties.showUp) {
            // If a meeting was updated after it was supposed to start, it is reasonable to expect it to be confirmed.
            if (moment(meeting.LastUpdated).isSameOrAfter(moment(meeting.StartDateTime)) && moment(meeting.LastUpdated).isSameOrBefore(meeting.EndDateTime)) {
                this.handleMeeting(meeting);
                return meeting;
            } else {
                if (moment.duration(moment(moment()).startOf("minute").diff(moment(meeting.StartDateTime).startOf("minute"))).asMinutes() < this.renderModel.properties.roomRelease) {
                    this.meetingToConfirm = meeting;
                } else {
                    this.hub.invoke("cancelAppointment", meeting.Id, this.solutionProps.roomEmail).done((result: any) => {
                        if (result) this.load();
                    });
                }
                this.handleMeeting(null);
                return;
            }
        }

        this.handleMeeting(meeting);
        return meeting;
    }

    get nextMeeting() {
        const now = this.now;
        if (this.data) {
            return this.data.filter((x: CalendarData) => moment(x.StartDateTime).isSameOrAfter(moment()))[0];
        }
    }

    get timeUntilNextMeeting() {
        if (this.nextMeeting && !this.currentMeeting && !this.isBookingDisabled) {
            const minutes = moment.duration(moment(this.nextMeeting.StartDateTime).startOf("minute").diff(this.now.startOf("minute"))).asMinutes();
            if (minutes <= 15) return minutes;
        }
    }

    get timeUntilRoomReleased() {
        if (this.meetingToConfirm) {
            const minutes = this.renderModel.properties.roomRelease - moment.duration(moment(this.now).startOf("minute").diff(moment(this.meetingToConfirm.StartDateTime).startOf("minute"))).asMinutes();
            if (minutes <= this.renderModel.properties.roomRelease) return minutes;
        }
    }

    get styles() {
        return `
            font-family: "${this.renderModel.properties.font ? this.renderModel.properties.font : "verdana"}";
        `;
    }

    // Life cycle
    mounted() {
        this.now = this.setNowWithLocale();

        if (!this.signalRMounted && !this.renderModel.properties.disableBooking && !this.preview) {
            this.mountSignalR();
            this.signalRMounted = true;
        }
        const timeUntilNextMinute = 60 - moment().seconds();
        this.timeout = setTimeout(() => {
            this.now = this.setNowWithLocale();
            this.interval = setInterval(() => {
                this.now = this.setNowWithLocale();
            }, 60000);
        }, timeUntilNextMinute * 1000); // Starts an internal timer so we can keep track of when next meetings are supposed to happen. Also used for dial information.
    }

    beforeDestroy() {
        clearTimeout(this.timeout);
        clearInterval(this.interval);
    }

    // Methods
    load() {
        this.loadData(false);
    }

    confirmMeeting(value: string) {
        const today = moment();
        this.data.filter((x: CalendarData) => moment(x.StartDateTime).set("seconds", 0).isSameOrBefore(today) && moment(x.EndDateTime).isAfter(today))[0].LastUpdated = value;
    }

    handleMeeting(meeting: CalendarData | null) {
        if (meeting) {
            if (this.oldMeeting && meeting.Id === this.oldMeeting.Id && moment(this.oldMeeting.StartDateTime).set("seconds", 0).isSame(moment(meeting.StartDateTime).set("seconds", 0)) && moment(this.oldMeeting.EndDateTime).isSame(moment(meeting.EndDateTime))) {
                return;
            }
            if (this.oldMeeting && this.oldMeeting.Id !== meeting.Id && this.renderModel.properties.automaticDisplayOff) {
                console.log("Meeting has ended but another started back to back. Turning off screen regardless.");
                this.turnOff();
            }
            this.oldMeeting = meeting;
            if ((this.$refs.dialElement as any)) (this.$refs.dialElement as any).startDial(moment(meeting.EndDateTime));
        } else {
            if ((this.$refs.dialElement as any) && this.oldMeeting !== null) (this.$refs.dialElement as any).stopDial();
            if (meeting && this.renderModel.properties.automaticDisplayOff && !this.isBookingDisabled) {
                console.log("Meeting has ended, turning off screen");
                this.$emit("turnOff");
            }
            this.oldMeeting = null;
        }
    }

    turnOn() {
        this.screenOn = true;
        setScreenON();
        setVideoPort(0).then(() => {
            console.log("Changed port to", 0);
        }).catch(() => {
            console.log("Error changing port");
        });
        setVideoSwitchON();
    }

    turnOff() {
        this.screenOn = false;
        (this.$refs.mainArea as any).selectButton(0);
        setScreenOFF();
        setVideoSwitchOFF();
    }

    setNowWithLocale() {
        if (this.renderModel.properties && this.renderModel.properties.language) return moment().locale(this.renderModel.properties.language);
        return moment().locale("en");
    }
}
